
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/shuraa-tax-accounting-auditing",
      function () {
        return require("private-next-pages/case-study/shuraa-tax-accounting-auditing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/shuraa-tax-accounting-auditing"])
      });
    }
  